import { render, staticRenderFns } from "./GovernanceAgent.vue?vue&type=template&id=588cad00&scoped=true"
import script from "./GovernanceAgent.vue?vue&type=script&lang=js"
export * from "./GovernanceAgent.vue?vue&type=script&lang=js"
import style0 from "./GovernanceAgent.vue?vue&type=style&index=0&id=588cad00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588cad00",
  null
  
)

export default component.exports